import * as validators from '../../../../constants/validators';

export const config = {
  password: validators.password,
  confirm: {
    rules: [
      {
        required: true,
        message: 'Please enter a password.',
      },
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (!value || getFieldValue('password') === value) {
            return Promise.resolve();
          }

          return Promise.reject(new Error('The two passwords that you entered do not match!'));
        },
      }),
    ],
  },
};
